import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { Tarea } from 'app/models/tareas.model';
import { DateTime } from 'luxon';
import { DetalleTareaService } from 'app/modules/admin/detalle-tareas/detalle-tareas-service';
import { UtilsService } from 'app/modules/utils-service';

@Component({
    selector: 'modal-cambiar-fecha-limite',
    templateUrl: './cambiar-fecha-limite.component.html',
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatLuxonDateModule,
    ]
})
export class CambiarFechaLimiteComponent {
    fechaSeleccionada: DateTime | null;
    minDate: DateTime = DateTime.now().startOf('day');

    // No permitir fechas pasadas
    dateFilter = (d: DateTime | null): boolean => {
        if (!d) return false;
        return d.startOf('day') >= this.minDate;
    };

    constructor(
        public dialogRef: MatDialogRef<CambiarFechaLimiteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { tarea: Tarea },
        private detalleTareaService: DetalleTareaService,
        private utilsSeervice: UtilsService
    ) {
        const actual = data?.tarea?.fechaLimite;
        this.fechaSeleccionada = actual ? DateTime.fromISO(actual) : null;
    }

    cerrar(): void {
        this.dialogRef.close();
    }


    guardar(): void {
        const fechaIso = this.fechaSeleccionada.toISODate();
        this.detalleTareaService
            .putFechaLimite(this.data.tarea.tareaUuid, fechaIso)
            .then((response:any) => {
                // Refrescar datos de la tarea
                this.detalleTareaService.getActividadesByTask(this.data.tarea.tareaUuid);
                this.detalleTareaService.getTaskDetails(this.data.tarea.tareaUuid);
                this.utilsSeervice.openSuccessSnakBar(response.message)
                this.dialogRef.close(true);
            })
            .catch(() => {
                this.dialogRef.close(false);
            });
    }
}
